export default {"src":"__ASTRO_ASSET_IMAGE__BfZ2OiBD__","width":882,"height":746,"format":"png"}